import { createFileRoute } from "@tanstack/react-router";

import { UpsellAwareSaasApp } from "@/components/app/UpsellAwareSaasApp";
import { AuthProvider } from "@/hooks/useAuth";

export const Route = createFileRoute("/")({
  component: IndexPage,
  head: () => ({
    meta: [
      { title: "100 Códigos Transformadores do Amor" },
      {
        name: "description",
        content:
          "Seu espaço para entender o momento amoroso, receber recomendações personalizadas e praticar os 100 Códigos Transformadores do Amor.",
      },
      { property: "og:title", content: "100 Códigos Transformadores do Amor" },
      {
        property: "og:description",
        content:
          "Entenda seu momento, receba recomendações e pratique os 100 Códigos Transformadores do Amor.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: "/" }],
  }),
});

function IndexPage() {
  return (
    <AuthProvider>
      <UpsellAwareSaasApp />
    </AuthProvider>
  );
}
